/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiSharepointDocumentLinkProjectIdParams,
  PostApiSharepointUploadPhotoProjectIdBody,
  ProjectPhotoDto,
  ProjectPhotoUploadResult
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiSharepointPostProjectId = (
    projectId: string,
 signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/api/Sharepoint/post/${projectId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiSharepointPostProjectIdMutationKey = () => ['postApiSharepointPostProjectId'] as const;

export const getPostApiSharepointPostProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointPostProjectId>>, TError,PostApiSharepointPostProjectIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointPostProjectId>>, TError,PostApiSharepointPostProjectIdMutationVariables, TContext> => {

const mutationKey = getPostApiSharepointPostProjectIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSharepointPostProjectId>>, PostApiSharepointPostProjectIdMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiSharepointPostProjectId(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSharepointPostProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSharepointPostProjectId>>>

    export type PostApiSharepointPostProjectIdMutationError = ErrorType<unknown>
    export type PostApiSharepointPostProjectIdMutationVariables = {projectId: string}

    export const usePostApiSharepointPostProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointPostProjectId>>, TError,PostApiSharepointPostProjectIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSharepointPostProjectId>>,
        TError,
        PostApiSharepointPostProjectIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiSharepointPostProjectIdMutationOptions(options), queryClient);
    }
    export const getApiSharepointDocumentLinkProjectId = (
    projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams,
 signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/api/Sharepoint/document-link/${projectId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiSharepointDocumentLinkProjectIdQueryKey = (projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams,) => {
    return [
    `/api/Sharepoint/document-link/${projectId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSharepointDocumentLinkProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError = ErrorType<unknown>>(projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSharepointDocumentLinkProjectIdQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>> = ({ signal }) => getApiSharepointDocumentLinkProjectId(projectId,params, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSharepointDocumentLinkProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>>
export type GetApiSharepointDocumentLinkProjectIdQueryError = ErrorType<unknown>


export function useGetApiSharepointDocumentLinkProjectId<TData = Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError = ErrorType<unknown>>(
 projectId: number,
    params: undefined |  GetApiSharepointDocumentLinkProjectIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharepointDocumentLinkProjectId<TData = Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError = ErrorType<unknown>>(
 projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharepointDocumentLinkProjectId<TData = Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError = ErrorType<unknown>>(
 projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSharepointDocumentLinkProjectId<TData = Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError = ErrorType<unknown>>(
 projectId: number,
    params?: GetApiSharepointDocumentLinkProjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointDocumentLinkProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSharepointDocumentLinkProjectIdQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSharepointProjectPhotosProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<ProjectPhotoDto[]>(
      {url: `/api/Sharepoint/project-photos/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSharepointProjectPhotosProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/Sharepoint/project-photos/${projectId}`
    ] as const;
    }


export const getGetApiSharepointProjectPhotosProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSharepointProjectPhotosProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>> = ({ signal }) => getApiSharepointProjectPhotosProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSharepointProjectPhotosProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>>
export type GetApiSharepointProjectPhotosProjectIdQueryError = ErrorType<unknown>


export function useGetApiSharepointProjectPhotosProjectId<TData = Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharepointProjectPhotosProjectId<TData = Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSharepointProjectPhotosProjectId<TData = Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSharepointProjectPhotosProjectId<TData = Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSharepointProjectPhotosProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSharepointProjectPhotosProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiSharepointUploadPhotoProjectId = (
    projectId: number,
    postApiSharepointUploadPhotoProjectIdBody?: BodyType<PostApiSharepointUploadPhotoProjectIdBody>,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiSharepointUploadPhotoProjectIdBody?.File !== undefined) {
 formData.append(`File`, postApiSharepointUploadPhotoProjectIdBody.File);
 }
if(postApiSharepointUploadPhotoProjectIdBody?.RequirementTitle !== undefined) {
 formData.append(`RequirementTitle`, postApiSharepointUploadPhotoProjectIdBody.RequirementTitle);
 }

      return customInstance<ProjectPhotoUploadResult>(
      {url: `/api/Sharepoint/upload-photo/${projectId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPostApiSharepointUploadPhotoProjectIdMutationKey = () => ['postApiSharepointUploadPhotoProjectId'] as const;

export const getPostApiSharepointUploadPhotoProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>, TError,PostApiSharepointUploadPhotoProjectIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>, TError,PostApiSharepointUploadPhotoProjectIdMutationVariables, TContext> => {

const mutationKey = getPostApiSharepointUploadPhotoProjectIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>, PostApiSharepointUploadPhotoProjectIdMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  postApiSharepointUploadPhotoProjectId(projectId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSharepointUploadPhotoProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>>
    export type PostApiSharepointUploadPhotoProjectIdMutationBody = BodyType<PostApiSharepointUploadPhotoProjectIdBody> | undefined
    export type PostApiSharepointUploadPhotoProjectIdMutationError = ErrorType<unknown>
    export type PostApiSharepointUploadPhotoProjectIdMutationVariables = {projectId: number;data?: BodyType<PostApiSharepointUploadPhotoProjectIdBody>}

    export const usePostApiSharepointUploadPhotoProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>, TError,PostApiSharepointUploadPhotoProjectIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSharepointUploadPhotoProjectId>>,
        TError,
        PostApiSharepointUploadPhotoProjectIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiSharepointUploadPhotoProjectIdMutationOptions(options), queryClient);
    }
    export const postApiSharepointArchiveProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Sharepoint/archive/${projectId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiSharepointArchiveProjectIdMutationKey = () => ['postApiSharepointArchiveProjectId'] as const;

export const getPostApiSharepointArchiveProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>, TError,PostApiSharepointArchiveProjectIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>, TError,PostApiSharepointArchiveProjectIdMutationVariables, TContext> => {

const mutationKey = getPostApiSharepointArchiveProjectIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>, PostApiSharepointArchiveProjectIdMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  postApiSharepointArchiveProjectId(projectId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSharepointArchiveProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>>

    export type PostApiSharepointArchiveProjectIdMutationError = ErrorType<unknown>
    export type PostApiSharepointArchiveProjectIdMutationVariables = {projectId: number}

    export const usePostApiSharepointArchiveProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>, TError,PostApiSharepointArchiveProjectIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSharepointArchiveProjectId>>,
        TError,
        PostApiSharepointArchiveProjectIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiSharepointArchiveProjectIdMutationOptions(options), queryClient);
    }
